import { ajax } from './helpers';

export class Reviews {
  constructor(el) {
    this.$wrapper = el;
    this.$grid = this.$wrapper.querySelector('.grid');
    this.page = 1;
    this.$loadMore = this.$wrapper.querySelector('.load-more');

    document.addEventListener('click', (event) => {
      if (event.target.matches('.read-more')) {
        qOne('.modal-review-mini').innerHTML =
          event.target.closest('.review-mini').outerHTML;
        qOne('#modal-review').control.open();
      }
    });

    this.$loadMore &&
      this.$loadMore.addEventListener('click', this.load.bind(this));
  }

  async load() {
    ++this.page;

    this.$loadMore.setAttribute('disabled', 'disabled');
    const response = await ajax('load_more_posts', {
      page: this.page,
      per_page: this.$wrapper.dataset.perPage,
    });
    this.$loadMore.removeAttribute('disabled');

    !response.data.has_more && this.$loadMore.remove();
    this.$grid.innerHTML += response.data.html;
  }
}

export class Portfolio {
  constructor(el) {
    this.$wrapper = el;
    this.$grid = this.$wrapper.querySelector('.projects-list');
    this.page = 1;
    this.$loadMore = this.$wrapper.querySelector('.load-more');

    this.$loadMore &&
      this.$loadMore.addEventListener('click', this.load.bind(this));
  }

  async load() {
    ++this.page;

    this.$loadMore.setAttribute('disabled', 'disabled');
    const response = await ajax('load_more_posts', {
      page: this.page,
      per_page: this.$wrapper.dataset.perPage,
      post_type: this.$wrapper.dataset.postType,
    });
    this.$loadMore.removeAttribute('disabled');

    !response.data.has_more && this.$loadMore.remove();
    this.$grid.innerHTML += response.data.html;
  }
}
